// React
import React, { useCallback, useState } from 'react'

// Components
import { Button } from '@/components/ui/button'

// Utils
import { useSession } from '@/utils/auth/user-context'
import { setupGeneralApiClient } from '@/utils/clients/general-api'

// External
import toast from 'react-hot-toast'
import { Loader2, StarOff } from 'lucide-react'
import { useTranslation } from 'next-i18next'

type UnStarButtonProps = {
  resultId: number
  callback: () => void
}

const UnStarButton: React.FC<UnStarButtonProps> = ({ resultId, callback }) => {
  const { t } = useTranslation('components/meme-editor')
  const session = useSession()
  const [isUnStarring, setIsUnStarring] = useState(false)

  const unStarMeme = useCallback(async () => {
    setIsUnStarring(true)
    try {
      const apiClient = setupGeneralApiClient(
        session.user,
        session.access_token
      )
      await apiClient.unstarResult(resultId)

      callback()
      toast.success(t('buttons.unstar.success'))
    } catch (error) {
      toast.error(t('buttons.unstar.error'))
    } finally {
      setIsUnStarring(false)
    }
  }, [resultId, session, t, callback])

  return (
    <Button
      size='sm'
      variant='ghost'
      disabled={isUnStarring}
      onClick={unStarMeme}
      className='h-8 w-8 p-0'
      title={t('buttons.unstar.label')}
    >
      {isUnStarring ? (
        <Loader2 className='h-4 w-4 animate-spin' />
      ) : (
        <StarOff className='h-4 w-4 text-yellow-500' />
      )}
    </Button>
  )
}

export { UnStarButton }
